import { CfsHtmlTemplateStyleType } from "clearline-api";

export class HtmlTemplateUtils {
  private static readonly noQrCodeStyles = [CfsHtmlTemplateStyleType.Style3, CfsHtmlTemplateStyleType.Style4];
  private static readonly noImgStyles = [CfsHtmlTemplateStyleType.Style5, CfsHtmlTemplateStyleType.Style6];
  private static readonly swappedMediaStyles = [CfsHtmlTemplateStyleType.Style7, CfsHtmlTemplateStyleType.Style8];

  static isNoQrCodeStyle(styleType: CfsHtmlTemplateStyleType): boolean {
    return this.noQrCodeStyles.includes(styleType);
  }

  static isNoImgStyle(styleType: CfsHtmlTemplateStyleType): boolean {
    return this.noImgStyles.includes(styleType);
  }

  static isSwappedMediaStyle(styleType: CfsHtmlTemplateStyleType): boolean {
    return this.swappedMediaStyles.includes(styleType);
  }
}
